import styled from 'styled-components';

export const StyledDunsWrapperDiv = styled.div`
  // TODO we could not figure out a more elegant way, explore later
  vertical-align: -webkit-baseline-middle;
  display: inline-block;
`;
